import * as Yup from 'yup';
import i18n from '../../../config/i18n';

export const validationSchema = Yup.object()
  .shape({
    issueDateFrom: Yup.string(),
    issueDateTo: Yup.string(),
    vatAccountNumber: Yup.string()
      .nullable()
      .test('vat-format', function (value) {
        // Only validate if vatAccountNumber has a value
        if (!value) {
          return true;
        }

        // Check if value starts with 20, 21, or 22 and is exactly 15 digits
        const vatPattern = /^(20|21|22)\d{13}$/;
        if (!vatPattern.test(value)) {
          return this.createError({
            path: 'vatAccountNumber',
            message: i18n.t('invoice_list.vat_number_format_error'),
          });
        }
        return true;
      }),
  })
  .test(function (value) {
    const { issueDateFrom, issueDateTo, issueDateType } = value || {};

    if (issueDateType === 'dateRange' && issueDateFrom && !issueDateTo) {
      return this.createError({
        path: 'issueDateTo',
        message: i18n.t('invoice_list.both_dates_are_required'),
      });
    }

    if (issueDateType === 'dateRange' && issueDateTo && !issueDateFrom) {
      return this.createError({
        path: 'issueDateFrom',
        message: i18n.t('invoice_list.both_dates_are_required'),
      });
    }
  })
  .test(function (value) {
    const { resolutionDateFrom, resolutionDateTo, issueDateType } = value || {};

    if (
      issueDateType === 'dateRange' &&
      resolutionDateFrom &&
      !resolutionDateTo
    ) {
      return this.createError({
        path: 'resolutionDateTo',
        message: i18n.t('invoice_list.both_dates_are_required'),
      });
    }

    if (
      issueDateType === 'dateRange' &&
      resolutionDateTo &&
      !resolutionDateFrom
    ) {
      return this.createError({
        path: 'resolutionDateFrom',
        message: i18n.t('invoice_list.both_dates_are_required'),
      });
    }
  });

export const initialValues = {
  invoiceType: '',
  issueDateType: 'dateRange',
  issueDateFrom: '',
  issueDateTo: '',
  issueDate: '',
  invoiceNumber: '',
  invoiceSubType: [],
  vatAccountType: '',
  vatAccountNumber: '',
  netAmountType: 'range',
  netMinAmount: '',
  netMaxAmount: '',
  vatAmountType: 'range',
  vatMinAmount: '',
  vatMaxAmount: '',
  grossAmountType: 'range',
  grossMinAmount: '',
  grossMaxAmount: '',
  transactionType: [],
  generatedBy: [],
  fullOrSimplified: [],
  buyerName: '',
};
